import { transportOrderFragment } from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const createTransportTemplate = gql`
    mutation createTransport(
        $clinic: ID!
        $serviceCode: TransportServices!
        $transportDay: String!
        $manualPackageCount: Int!
        $lab: ID
        $comment: String
        $deadline: String
        $internalMessage: String
        $userSelectedDate: String
    ) {
        createTransport(
            clinic: $clinic
            serviceCode: $serviceCode
            transportDay: $transportDay
            manualPackageCount: $manualPackageCount
            lab: $lab
            comment: $comment
            deadline: $deadline
            internalMessage: $internalMessage
            userSelectedDate: $userSelectedDate
        ) {
            _id
        }
    }
`;

export const createTransportAsAdminTemplate = gql`
    mutation createTransportAsAdmin(
        $clinic: ID!
        $serviceCode: TransportServices!
        $transportDay: String!
        $manualPackageCount: Int!
        $lab: ID
        $comment: String
        $deadline: String
        $internalMessage: String
        $isAlreadyCollected: Boolean
    ) {
        createTransportAsAdmin(
            clinic: $clinic
            serviceCode: $serviceCode
            transportDay: $transportDay
            manualPackageCount: $manualPackageCount
            lab: $lab
            comment: $comment
            deadline: $deadline
            internalMessage: $internalMessage
            isAlreadyCollected: $isAlreadyCollected
        ) {
            _id
        }
    }
`;

export const updateTransportTemplate = gql`
    mutation updateTransport(
        $transportOrderId: MongoDbObjectId!
        $manualPackageCount: Int
        $comment: String
        $internalMessage: String
        $deadline: String
    ) {
        updateTransport(
            transportOrderId: $transportOrderId
            manualPackageCount: $manualPackageCount
            comment: $comment
            internalMessage: $internalMessage
            deadline: $deadline
        ) {
            ...transportOrderFields
        }
    }
    ${transportOrderFragment}
`;

export const revokeTransportTemplate = gql`
    mutation revokeTransport($transportOrderId: MongoDbObjectId!, $userSelectedDate: String) {
        revokeTransport(transportOrderId: $transportOrderId, userSelectedDate: $userSelectedDate)
    }
`;

export const updateTransportHasProblemTemplate = gql`
    mutation updateTransportHasProblem($_id: MongoDbObjectId!) {
        updateTransportHasProblem(_id: $_id)
    }
`;

export const setOrderReadyForDeliveryTemplate = gql`
    mutation setOrderReadyForDelivery($orderId: MongoDbObjectId!) {
        setOrderReadyForDelivery(orderId: $orderId) {
            _id
            isReadyForDelivery
        }
    }
`;

export const unsetOrderReadyForDeliveryTemplate = gql`
    mutation unsetOrderReadyForDelivery($orderId: MongoDbObjectId!) {
        unsetOrderReadyForDelivery(orderId: $orderId) {
            _id
            isReadyForDelivery
        }
    }
`;

export const createTransportForOrderTemplate = gql`
    mutation createTransportForOrder(
        $clinic: MongoDbObjectId!
        $serviceCode: TransportServices!
        $transportDay: String!
        $manualPackageCount: Int!
        $orderId: String!
        $comment: String
        $dentistName: String
        $internalMessage: String
        $userSelectedDate: String
        $deadline: String
    ) {
        createTransportForOrder(
            clinic: $clinic
            serviceCode: $serviceCode
            transportDay: $transportDay
            manualPackageCount: $manualPackageCount
            comment: $comment
            orderId: $orderId
            dentistName: $dentistName
            internalMessage: $internalMessage
            userSelectedDate: $userSelectedDate
            deadline: $deadline
        ) {
            _id
            deliveryDetails {
                isLabHandleRequest
            }
            currentPickup {
                ...transportOrderFields
            }
            currentDelivery {
                ... on TransportOrder {
                    ...transportOrderFields
                }
                ... on NShiftShipmentWaybill {
                    shipDate
                    orderNo
                    shipmentStatus: status
                    prints {
                        id
                        fileUrl
                        type
                    }
                }
            }
        }
    }
    ${transportOrderFragment}
`;

export const createNShiftShipmentWaybillsTemplate = gql`
    mutation createNShiftShipmentWaybills(
        $clinic: MongoDbObjectId!
        $transportDay: Date!
        $manualPackageCount: Int
        $comment: String
        $weight: Float!
        $orderIds: [String!]!
        $service: String!
        $partnerId: String!
        $internalMessage: String
        $packageSizeId: String
    ) {
        createNShiftShipmentWaybills(
            clinic: $clinic
            transportDay: $transportDay
            manualPackageCount: $manualPackageCount
            comment: $comment
            weight: $weight
            orderIds: $orderIds
            service: $service
            partnerId: $partnerId
            internalMessage: $internalMessage
            packageSizeId: $packageSizeId
        )
    }
`;

export const printWaybillTemplate = gql`
    mutation printWaybill($waybillId: String!) {
        printWaybill(waybillId: $waybillId) {
            _id
            id
            status
            prints {
                id
                fileUrl
            }
        }
    }
`;

export const printWaybillsTemplate = gql`
    mutation printWaybills {
        printWaybills
    }
`;

export const deleteWaybillTemplate = gql`
    mutation deleteWaybill($waybillId: String!) {
        deleteWaybill(waybillId: $waybillId)
    }
`;

export const updateTransportForOrderTemplate = gql`
    mutation updateTransportForOrder(
        $transportOrderId: MongoDbObjectId!
        $clinic: MongoDbObjectId!
        $transportDay: String!
        $manualPackageCount: Int!
        $orderId: String!
        $comment: String
        $dentistName: String
        $internalMessage: String
        $userSelectedDate: String
    ) {
        updateTransportForOrder(
            transportOrderId: $transportOrderId
            clinic: $clinic
            transportDay: $transportDay
            manualPackageCount: $manualPackageCount
            comment: $comment
            orderId: $orderId
            dentistName: $dentistName
            internalMessage: $internalMessage
            userSelectedDate: $userSelectedDate
        ) {
            _id
            deliveryDetails {
                isLabHandleRequest
            }
            currentPickup {
                ...transportOrderFields
            }
            currentDelivery {
                ... on TransportOrder {
                    ...transportOrderFields
                }
                ... on NShiftShipmentWaybill {
                    shipDate
                    orderNo
                    shipmentStatus: status
                    prints {
                        id
                        fileUrl
                        type
                    }
                }
            }
        }
    }
    ${transportOrderFragment}
`;
